module.exports = __webpack_public_path__ + "img/custom-08.c38af58d.jpg";